import { BanksPage } from 'features/banks';

export const AdminBanksPage: React.FC = () => <BanksPage />;
